import * as React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import mobileTargeting from "../../../assets/images/featureFlag/targeting_mobile.png"
import targeting from "../../../assets/images/featureFlag/targeting.png"
import mobileTargetingEn from "../../../assets/images/featureFlag/targeting_mobile_en.png"
import targetingEn from "../../../assets/images/featureFlag/targeting_en.png"
import usePlatform from "../../../hooks/usePlatform"
import { Locale } from "../../../locale"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#fff",
      [theme.breakpoints.up("md")]: {},
    },
    wrapper: {
      boxSizing: "border-box",
      width: "100%",
      "& img": {
        width: "100%",
      },
      [theme.breakpoints.up("md")]: {
        width: "1248px",
        margin: "0 auto",
        fontSize: 0,
      },
    },
  })
)

export default function Targeting() {
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        {lang === "ko" ? (
          <img src={isMobile ? mobileTargeting : targeting} />
        ) : (
          <img src={isMobile ? mobileTargetingEn : targetingEn} />
        )}
      </div>
    </div>
  )
}
